/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentMethodSetupResponse
 */
export interface PaymentMethodSetupResponse {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodSetupResponse
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodSetupResponse
     */
    setupId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodSetupResponse
     */
    clientSecret: string;
}

/**
 * Check if a given object implements the PaymentMethodSetupResponse interface.
 */
// @ts-ignore
export function instanceOfPaymentMethodSetupResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "customerId" in value;
    isInstance = isInstance && "setupId" in value;
    isInstance = isInstance && "clientSecret" in value;

    return isInstance;
}

// @ts-ignore
export function PaymentMethodSetupResponseFromJSON(json: any): PaymentMethodSetupResponse {
    return PaymentMethodSetupResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function PaymentMethodSetupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodSetupResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customerId': json['customer_id'],
        'setupId': json['setup_id'],
        'clientSecret': json['client_secret'],
    };
}

// @ts-ignore
export function PaymentMethodSetupResponseToJSON(value?: PaymentMethodSetupResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customer_id': value.customerId,
        'setup_id': value.setupId,
        'client_secret': value.clientSecret,
    };
}

